module.exports = __webpack_public_path__ + "static/media/no-result.00088a1f.svg";